import img_dots from "assets/img/3-vertical-dots-icon.svg";

import { Box, Divider, IconButton, Menu } from "@mui/material";
import { MenuItemButtonUploadNotificationDocument } from "features/application-upload-notification-document/components/MenuItemButtonUploadNotificationDocument";
import { MenuItemButtonGoToDocument } from "features/go-to-document/components/MenuItemButtonGoToDocument";
import { useState } from "react";
import { MenuItemButtonAssignmentHistory } from "../../../../features/assingment-history/components/MenuItemButtonAssignmentHistory";
import { MenuItemButtonConstructAndDownloadNotificationDocument } from "./MenuItemButtonConstructAndDownloadNotificationDocument";
import { MenuItemButtonCountLines } from "./MenuItemButtonCountLines";
import { MenuItemButtonDownload } from "./MenuItemButtonDownload";
import { MenuItemButtonOpenAccessToApplication } from "./MenuItemButtonOpenAccessToApplication";
import { MenuItemButtonGoToSpreadsheet } from "./MenuItemGoToSpreadsheet";
import { MenuItemButtonProlongTime } from "./MenuItemButtonProlongTime";
import { MenuItemButtonDownloadNew } from "./MenuItemButtonDownloadNew";

export const AssignmentThreeDotsButton = ({
  assignmentId,
  spreadsheetLink,
  applicationId,
  signLink,
}: {
  assignmentId: number;
  applicationId: string;
  spreadsheetLink: string;
  signLink: string;
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        <Box component={"img"} src={img_dots} width={"20px"} height={"20px"} />
      </IconButton>
      <Menu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItemButtonGoToSpreadsheet
          spreadsheetLink={spreadsheetLink}
          handleClose={handleClose}
        />
        <MenuItemButtonGoToDocument
          signLink={signLink}
          onClickCallback={handleClose}
        />
        <MenuItemButtonOpenAccessToApplication applicationId={applicationId} />
        <MenuItemButtonCountLines assignmentId={assignmentId} />
        {/* <MenuItemButtonProlongTime assignmentId={assignmentId} />  */}
            <MenuItemButtonAssignmentHistory assignmentId={assignmentId} />
        <Divider
          sx={{
            my: "4px",
          }}
        />
        <MenuItemButtonConstructAndDownloadNotificationDocument
          applicationId={applicationId}
        />
        <MenuItemButtonUploadNotificationDocument assignmentId={assignmentId} />
        <Divider
          sx={{
            my: "4px",
          }}
        />
        <MenuItemButtonDownload assignmentId={assignmentId} />
        <MenuItemButtonDownloadNew assignmentId={assignmentId} />
      </Menu>
    </>
  );
};
